document.addEventListener('DOMContentLoaded', function () {
  function formatYmqPrice(price) {
    return price
      .trim()
      .replace(',00', '')
      .replace(/\s*KR/i, ',-');
  }

  function addPrices() {
    document.querySelectorAll('#ymq-box label').forEach(function (label) {
      if (label.querySelector(':scope > .ymq-visible-price')) return;

      var priceSpan = label.querySelector('.ymq-price-span');
      if (!priceSpan) return;

      var rawPrice = priceSpan.textContent.trim();

      if (!rawPrice) return;
      if (rawPrice === '0,00 KR') return;

      var visiblePrice = document.createElement('span');
      visiblePrice.className = 'ymq-visible-price';
      visiblePrice.textContent = '+' + formatYmqPrice(rawPrice);

      label.appendChild(visiblePrice);
    });
  }

  function formatExistingYmqPrices() {
    var ymqBox = document.querySelector('#ymq-box');
    if (!ymqBox) return;

    ymqBox.querySelectorAll('.ymq-price-span').forEach(function (el) {
      var oldText = el.textContent;
      var newText = formatYmqPrice(oldText);

      if (oldText !== newText) {
        el.textContent = newText;
      }
    });
  }

  function connectYmqSizeGuide() {
    var ymqTrigger = document.querySelector('.ymq-size-guide-trigger');
    var originalButton = document.querySelector('button[aria-controls^="size-chart-template"]');

    if (!ymqTrigger || !originalButton) return;
    if (ymqTrigger.dataset.connected === 'true') return;

    ymqTrigger.dataset.connected = 'true';

    ymqTrigger.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();

      originalButton.dispatchEvent(new MouseEvent('click', {
        bubbles: true,
        cancelable: true,
        view: window
      }));
    });
  }

  function runYmqFixes() {
    addPrices();
    formatExistingYmqPrices();
    connectYmqSizeGuide();
  }

  runYmqFixes();

  setTimeout(runYmqFixes, 500);
  setTimeout(runYmqFixes, 1500);
  setTimeout(runYmqFixes, 3000);
  setTimeout(runYmqFixes, 5000);
});
function updatePlankoaConfigBox() {
  const box = document.querySelector('#plankoa-config-box');
  if (!box) return;

  const content = box.querySelector('.content');
  const priceTarget = box.querySelector('.price');
  if (!content || !priceTarget) return;

  function formatPrice(text) {
    if (!text) return '';

    return text
      .trim()
      .replace(',00', '')
      .replace(/\s*KR/i, ',-')
      .replace(/\+\s+/g, '+');
  }

  function cleanOptionText(text) {
    if (!text) return '';

    return text
      .replace(/\+?\s*\d{1,3}(?:\.\d{3})*,00\s*KR/gi, '')
      .replace(/\+?\s*\d{1,3}(?:\.\d{3})*,-/gi, '')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function getPriceFromText(text) {
    if (!text) return '';

    const match =
      text.match(/\+?\s*\d{1,3}(?:\.\d{3})*,00\s*KR/i) ||
      text.match(/\+?\s*\d{1,3}(?:\.\d{3})*,-/i);

    if (!match) return '';

    let price = formatPrice(match[0]);
    if (!price.startsWith('+')) price = '+' + price;

    return price;
  }

  let rows = [];

  /* Select/dropdown options */
  document.querySelectorAll('#ymq-box select').forEach(function (select) {
    if (!select.value || select.value.toLowerCase().includes('vælg')) return;

    const group = select.closest('.ymq-options-box');
    const groupName = group
      ? (group.getAttribute('data-label') || group.getAttribute('data-name') || '')
      : '';

    const selectedOption = select.options[select.selectedIndex];
    const optionText = selectedOption ? selectedOption.textContent : select.value;

    rows.push(`
      <div class="config-line">
        <span><strong>${cleanOptionText(groupName)}:</strong> ${cleanOptionText(optionText)}</span>
        <span>${getPriceFromText(optionText) || 'Inkl.'}</span>
      </div>
    `);
  });

  /* Radio / image options */
  document.querySelectorAll('#ymq-box input:checked').forEach(function (input) {
    const groupName = input.name
      .replace('ymq[', '')
      .replace(']', '')
      .trim();

    const value = input.value ? input.value.trim() : '';
    if (!groupName || !value) return;

    let priceText = '';

    if (input.id) {
      const label = document.querySelector('#ymq-box label[for="' + CSS.escape(input.id) + '"]');

      if (label) {
        const priceSpan = label.querySelector('.ymq-price-span');
        if (priceSpan) {
          priceText = getPriceFromText(priceSpan.textContent);
        }
      }
    }

    rows.push(`
      <div class="config-line">
        <span><strong>${groupName}:</strong> ${cleanOptionText(value)}</span>
        <span>${priceText || 'Inkl.'}</span>
      </div>
    `);
  });

  content.innerHTML = rows.length
    ? rows.join('')
    : 'Vælg muligheder for at se dit valg.';

  const productPrice =
    document.querySelector('.product-info sale-price') ||
    document.querySelector('.product-info .sale-price') ||
    document.querySelector('.product-info .price-list sale-price') ||
    document.querySelector('.product-info .price-list');

  const productComparePrice =
  document.querySelector('.product-info compare-at-price') ||
  document.querySelector('.product-info .compare-at-price') ||
  document.querySelector('.product-info .price-list compare-at-price');

if (productPrice) {
  const salePrice = formatPrice(productPrice.textContent);
  const comparePrice = productComparePrice ? formatPrice(productComparePrice.textContent) : '';

  priceTarget.innerHTML = comparePrice
    ? `<span class="config-sale-price">${salePrice}</span> <span class="config-compare-price">VEJL. ${comparePrice}</span>`
    : `<span class="config-sale-price">${salePrice}</span>`;
}
}

setInterval(updatePlankoaConfigBox, 500);

document.addEventListener('DOMContentLoaded', function () {
  const target = document.querySelector('[data-trustpilot-count]');
  if (!target) return;

  const cacheKey = 'plankoa_trustpilot_review_count';
  const cacheTimeKey = 'plankoa_trustpilot_review_count_time';
  const maxAge = 24 * 60 * 60 * 1000; // 24 timer

  const cachedCount = localStorage.getItem(cacheKey);
  const cachedTime = localStorage.getItem(cacheTimeKey);

  // Brug cache hvis den er frisk
  if (cachedCount && cachedTime && Date.now() - Number(cachedTime) < maxAge) {
    target.textContent = formatNumber(cachedCount);
    return;
  }

  const trustpilotUrl = 'https://dk.trustpilot.com/review/plankoa.dk';
  const proxyUrl = 'https://api.allorigins.win/raw?url=' + encodeURIComponent(trustpilotUrl);

  fetch(proxyUrl)
    .then(response => response.text())
    .then(html => {
      const match =
        html.match(/Plankoa Home\s*Anmeldelser\s*([0-9.]+)/i) ||
        html.match(/([0-9.]+)\s+anmeldelser/i) ||
        html.match(/([0-9.]+)\s+i alt/i);

      if (!match || !match[1]) {
        useFallback();
        return;
      }

      const count = match[1].replace(/\./g, '');

      localStorage.setItem(cacheKey, count);
      localStorage.setItem(cacheTimeKey, Date.now().toString());

      target.textContent = formatNumber(count);
    })
    .catch(useFallback);

  function useFallback() {
    if (cachedCount) {
      target.textContent = formatNumber(cachedCount);
    } else {
      target.textContent = '300+'; // fallback hvis alt fejler
    }
  }

  function formatNumber(num) {
    return new Intl.NumberFormat('da-DK').format(num);
  }
});